import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconBlurbs = props => (
  <SvgIcon {...props} viewBox="0 0 18 16.7017">
    <path fillRule="evenodd" d="m17.125 2.9473h-2.0956v7.8565h-11.029v1.5996c0 0.4728 0.39375 0.8597 0.875 0.8597h9.625l3.5 3.4386v-12.895c0-0.4735-0.394-0.8603-0.875-0.8603zm-4.125 5.5673v-7.6631c0-0.46834-0.39-0.8515-0.867-0.8515h-11.266c-0.477 0-0.867 0.38316-0.867 0.85146v11.921l3.4667-3.4059h8.6666c0.477 0 0.867-0.3832 0.867-0.8515z" />
  </SvgIcon>
);

export default IconBlurbs;



// WEBPACK FOOTER //
// ./src/components/icons/IconBlurbs.js